import React, { useContext } from 'react';
import ConnectAsContext from 'contexts/connect_as/context';

export const useConnectAs = () => {
  return useContext(ConnectAsContext);
};
